import { combineReducers } from "redux";

import * as authActionTypes from "./auth/actionTypes";
import _notif from "./notification";
import _auth from "./auth";
import _adminBooking from "./adminBooking";

const appReducer = combineReducers({
  notif: _notif.reducer,

  auth: _auth.reducer,
  adminBooking: _adminBooking.reducer,
});

const rootReducer = (state, action) => {
  //Reset the admin state on logout
  if (action.type === authActionTypes.LOGOUT) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
